import React from 'react';
import { WrapFullEmtpyDates, WrapFullEmtpyDatesBackground } from './styles';
import EmptyDatesImage from '../../../assets/backgrounds/empty-dates.svg';

const FullEmptyDates = () => (
  <WrapFullEmtpyDates>
    <h3>Aún no tienes fechas acádemicas</h3>
    <WrapFullEmtpyDatesBackground src={EmptyDatesImage} />
  </WrapFullEmtpyDates>
);

export { FullEmptyDates };
